import { Dispatch, FC, SyntheticEvent, useCallback, useState } from "react";
import { AxiosInstance } from "axios";
import { AlertType } from "../../../../../types/AlertType";
import { IYearsVerouillageClotureLocked } from "../../../budget/ColumnHeader";
import { StyledTableCell, Transition } from "../../../budget/BudgetRow";
import { TableRow, Stack, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Accordion, AccordionDetails, AccordionSummary, Box, Card, CardContent, Divider, List, ListItem, ListItemText, Typography } from "@mui/material";
import { AllMounth, PROFIL_SUPER_ADMIN, profilAllAccessBudgetSiVerouiller, profilToAccessFromSaisieManager } from "../../../../../constants/Constants";
import { btnStyle } from "../../../parametrage/user/Tabs/utilisateur/UtilisateurRow";
import { ReforecastData } from "../../../../../types/DataReforecast";
import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { ConnectedUser } from "../../../../../utils/utils";
import { profilsCanManageBudget } from "../../../budget/Budget";
import { LoadingButton } from "@mui/lab";
import OptionalWidthModal from "../../../../../commons/optional-width-modal/OptionalWidthModal";
import DuplicateReforecastForm from "../../../../forms/reforecast/DuplicateReforecastForm";
import UpdateReforecastForm from "../../../../forms/reforecast/UpdateReforecastForm";
import { IYearsVerouillageClotureLockedReforcast } from "./ColumHeader";
import AccessTimeIcon from '@mui/icons-material/AccessTime';

interface ReforecastRowProps {
  reforecaste: ReforecastData;
  http: AxiosInstance;
  expanded: number | false;
  isDesktopOrLaptop: boolean;
  setExpanded: Dispatch<React.SetStateAction<number | false>>;
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
  reloadList: () => void;
  dateVerrouillageCloture: IYearsVerouillageClotureLockedReforcast
}

const ReforecastRow: FC<ReforecastRowProps> = ({
  reforecaste,
  http,
  expanded,
  isDesktopOrLaptop,
  setExpanded,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  reloadList,
  dateVerrouillageCloture
}) => {
  const user = ConnectedUser();
  const bgColorEditBtn = profilToAccessFromSaisieManager.includes(user?.profils?.libelle) ? "#070d23" : "#1A168C";

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
  const [openDuplicateModal, setOpenDuplicateModal] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const handleDelete = useCallback(() => {
    setDeleteLoading(true);
    http.delete(`reforecast/delete/${reforecaste?.id}`).then(() => {
      setOpenModalDelete(false);
      setDeleteLoading(false);
      reloadList();
      setAlerteMessage("Suppresion efféctuée !");
      setAlertType("success");
      setOpenSnack(true);
      reloadList();
    }).catch(error => {
      console.log(error);
    });
  }, []);

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleCloseDeleteModal = () => {
    setOpenModalDelete(false);
  };

  const handleCloseDuplicateModal = () => {
    setOpenDuplicateModal(false);
  };

  const disableDeleteBtn = (): boolean => {
    /**
     * Le bouton “Supprimer” est grisé si article est prod (is_budget = 0) et profil user connecté est DRC
     */
    if (profilsCanManageBudget.includes(user?.profils?.libelle) && (reforecaste.article_budget !== 1)) {
      return true;
    }

    if (!profilToAccessFromSaisieManager.includes(user?.profils?.libelle) ||
      reforecaste?.article_actif === 0) {
      return true;
    }

    // Si Profil n'est pas super Admin et le reforecast est Cloturé
    if ((![PROFIL_SUPER_ADMIN].includes(user?.profils?.libelle)
      && dateVerrouillageCloture.YearsClotureReforcast.includes(reforecaste?.annee))) {
      return true;
    }

    // Si Profil n'est Pas ADV, Super Admin on block Si Le Budget est Verouillé Ou Budget n'est Pas Actif
    if ((!profilAllAccessBudgetSiVerouiller.includes(user?.profils?.libelle)
      && dateVerrouillageCloture?.YearsVerouillageReforcast.includes(reforecaste?.annee))) {
      return true;
    } else {
      /**
      * Le bouton “Modifier” est grisé si article est prod (is_budget = 0) et profil user connecté est DRC
      */
      if (profilsCanManageBudget.includes(user?.profils?.libelle) && (reforecaste.article_budget !== 1))
        return true;
    }

    return false;
  };

  const disableEditBtn = (): boolean => {
    // Si L'article n'est Pas Actif
    if (reforecaste?.article_actif === 0) return true;

    // Si Profil n'est pas super Admin et le Budget est Cloturé
    if ((![PROFIL_SUPER_ADMIN].includes(user?.profils?.libelle)
      && dateVerrouillageCloture.YearsClotureReforcast.includes(reforecaste?.annee))) {
      return true;
    }

    // Si Profil n'est Pas ADV, Super Admin on block Si Le Budget est Verouillé Ou Budget n'est Pas Actif
    if ((!profilAllAccessBudgetSiVerouiller.includes(user?.profils?.libelle)
      && dateVerrouillageCloture?.YearsVerouillageReforcast.includes(reforecaste?.annee))) {
      return true;
    } else {
      /**
      * Le bouton “Modifier” est grisé si article est prod (is_budget = 0) et profil user connecté est DRC
      */
      if (profilsCanManageBudget.includes(user?.profils?.libelle) && (reforecaste.article_budget !== 1))
        return true;
    }

    return false;
  }

  const clientValue = () => {
    if (reforecaste?.client_libelle) {
      return reforecaste?.client_libelle;
    }

    if (reforecaste?.client_budget_libelle) {
      return reforecaste?.client_budget_libelle;
    }

    if (reforecaste?.client_prod_for_article_budget_libelle) {
      return reforecaste?.client_prod_for_article_budget_libelle;
    }

    return null;
  };

  const operationValue = () => {
    if (reforecaste?.operation_libelle) {
      return reforecaste?.operation_libelle;
    }

    if (reforecaste?.operation_budget_libelle) {
      return reforecaste?.operation_budget_libelle;
    }

    return null;
  };

  const handleChangeAccordionValue = (panel: number) => (event: SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const deleteMessageConfirmation = ` Vous êtes sur le point de supprimer ce Reforecast, êtes-vous sûr de
  vouloir poursuivre cette action ?`;

  return (
    <>
      {isDesktopOrLaptop ? (
        <TableRow>
          <StyledTableCell>
            {reforecaste?.pays_libelle}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.bu_libelle}
          </StyledTableCell>
          <StyledTableCell>
            {clientValue()}
          </StyledTableCell>
          <StyledTableCell>
            {operationValue()}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.code_article_libelle}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.type_libelle}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.article_libelle}
          </StyledTableCell>
          <StyledTableCell>
            {AllMounth.find((x) => x.id === reforecaste?.mois)?.mounth}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.annee}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.ca_budget && parseFloat(reforecaste?.ca_budget)?.toFixed(2)}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.tx_marge_budget && parseFloat(reforecaste?.tx_marge_budget)?.toFixed(2)}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.marge_valeur_budget && parseFloat(reforecaste?.marge_valeur_budget)?.toFixed(2)}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.qte_heure_budget && parseFloat(reforecaste?.qte_heure_budget)?.toFixed(2)}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.qte_acte_budget && parseFloat(reforecaste?.qte_acte_budget)?.toFixed(2)}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.dmt ? (
              <Box display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                <AccessTimeIcon sx={{ fontSize: '1rem' }} />
                <span>{reforecaste?.dmt}</span>
              </Box>
            ) : ""}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.taux_occupation !== null && reforecaste?.taux_occupation !== undefined ? `${reforecaste?.taux_occupation} %` : ""}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.taux_conges !== null && reforecaste?.taux_conges !== undefined ? `${reforecaste?.taux_conges} %` : ""}
          </StyledTableCell>
          <StyledTableCell>
            {reforecaste?.taux_absenteisme !== null && reforecaste?.taux_absenteisme !== undefined ? `${reforecaste?.taux_absenteisme} %` : ""}
          </StyledTableCell>
          {/*<StyledTableCell>
            {budget?.heure_cout_budget && parseFloat(String(budget?.heure_cout_budget))?.toFixed(2)}
          </StyledTableCell>*/}
          <StyledTableCell>
            <Stack
              direction="row"
              spacing={1}
              display="flex"
              justifyContent="center"
            >
              <Button
                size="small"
                variant="outlined"
                sx={btnStyle({
                  bgColor: bgColorEditBtn,
                  hoverColor: "Gray",
                  color: "#fff",
                })}
                startIcon={<BorderColorIcon />}
                onClick={() => setOpenModal(true)}
                disabled={disableEditBtn()}
              >
                Modifier
              </Button>
              <Button
                size="small"
                variant="outlined"
                sx={btnStyle({
                  bgColor: "#FF0000",
                  hoverColor: "#FE3737",
                })}
                disabled={disableDeleteBtn()}
                startIcon={<DeleteIcon />}
                onClick={() => setOpenModalDelete(true)}
              >
                Supprimer
              </Button>

              <Button
                size="small"
                color="warning"
                variant="contained"
                startIcon={<ContentCopyIcon />}
                onClick={() => setOpenDuplicateModal(true)}
                sx={{ textTransform: 'none' }}
              >
                Dupliquer
              </Button>
            </Stack>
          </StyledTableCell>
        </TableRow>
      ) : (
        <Accordion
          expanded={expanded === reforecaste?.id}
          onChange={handleChangeAccordionValue(reforecaste?.id as number)}
          sx={{
            borderRadius: 1,
            bgcolor: "#fff",
            mb: 1,
            ml: 0.1
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#080d24" }} />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Stack direction="column">
              <List sx={{ py: 0 }} dense>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Désignation Article:"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: "#FC8404" }}>
                        {reforecaste?.article_libelle}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Code Article :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: "#FC8404" }}>
                        {reforecaste?.code_article_libelle}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Mois :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: "#FC8404" }}>
                        {AllMounth.find((x) => x.id === reforecaste?.mois)?.mounth}
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Stack direction="column" spacing={1}>
              <Button
                variant="contained"
                sx={btnStyle({
                  bgColor: "Gray",
                  hoverColor: "Gray",
                  color: "#fff",
                })}
                size="small"
                fullWidth
                disabled={reforecaste?.article_actif === 0}
                startIcon={<BorderColorIcon />}
                onClick={() => setOpenModal(true)}
              >
                Modifier
              </Button>
              <Button
                size="small"
                variant="contained"
                sx={btnStyle({
                  bgColor: "#FF0000",
                  hoverColor: "#FE3737",
                })}
                fullWidth
                disabled={disableDeleteBtn()}
                startIcon={<DeleteIcon />}
                onClick={() => setOpenModalDelete(true)}
              >
                Supprimer
              </Button>

              <Button
                size="small"
                color="warning"
                variant="contained"
                fullWidth
                startIcon={<ContentCopyIcon />}
                onClick={() => setOpenDuplicateModal(true)}
                sx={{ textTransform: 'none' }}
              >
                Dupliquer
              </Button>

              <Box mt={5}>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  sx={{ mb: 0 }}
                >
                  Détails
                </Typography>
                <Divider
                  orientation="horizontal"
                  sx={{ bgcolor: "#fff", mb: 1 }}
                />
              </Box>

              <Card>
                <CardContent>
                  <List dense>
                    <ListItem dense>
                      <ListItemText
                        primary="Pays :"
                        secondary={reforecaste?.pays_libelle}
                      />
                    </ListItem>

                    <Divider
                      orientation="horizontal"
                      sx={{ bgcolor: " #dfdfdf" }}
                    />
                    <ListItem dense>
                      <ListItemText
                        primary="Bu :"
                        secondary={reforecaste?.bu_libelle}
                      />
                    </ListItem>

                    <Divider
                      orientation="horizontal"
                      sx={{ bgcolor: " #dfdfdf" }}
                    />
                    <ListItem dense>
                      <ListItemText
                        primary="Client :"
                        secondary={reforecaste?.client_libelle}
                      />
                    </ListItem>

                    <Divider
                      orientation="horizontal"
                      sx={{ bgcolor: " #dfdfdf" }}
                    />
                    <ListItem dense>
                      <ListItemText
                        primary="Opération :"
                        secondary={reforecaste?.operation_libelle}
                      />
                    </ListItem>

                    {reforecaste?.ca_budget && (
                      <>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: " #dfdfdf" }}
                        />
                        <ListItem dense>
                          <ListItemText
                            primary="CA_Budget :"
                            secondary={parseFloat(reforecaste?.ca_budget)?.toFixed(2)}
                          />
                        </ListItem>
                      </>
                    )}

                    {reforecaste?.tx_marge_budget && (
                      <>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: " #dfdfdf" }}
                        />
                        <ListItem dense>
                          <ListItemText
                            primary="Taux_Marge_budget :"
                            secondary={parseFloat(reforecaste?.tx_marge_budget)?.toFixed(2)}
                          />
                        </ListItem>
                      </>
                    )}

                    {reforecaste?.marge_valeur_budget && (
                      <>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: " #dfdfdf" }}
                        />
                        <ListItem dense>
                          <ListItemText
                            primary="Marge_Valeur_budget :"
                            secondary={parseFloat(reforecaste?.marge_valeur_budget)?.toFixed(2)}
                          />
                        </ListItem>
                      </>
                    )}

                    {reforecaste?.qte_acte_budget && (
                      <>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: " #dfdfdf" }}
                        />
                        <ListItem dense>
                          <ListItemText
                            primary="Acte Budget :"
                            secondary={parseFloat(reforecaste?.qte_acte_budget)?.toFixed(2)}
                          />
                        </ListItem>
                      </>
                    )}

                    {reforecaste?.qte_heure_budget && (
                      <>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: " #dfdfdf" }}
                        />
                        <ListItem dense>
                          <ListItemText
                            primary="Heure Budget :"
                            secondary={parseFloat(reforecaste?.qte_heure_budget)?.toFixed(2)}
                          />
                        </ListItem>
                      </>
                    )}

                    {reforecaste?.heure_cout_budget && (
                      <>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: " #dfdfdf" }}
                        />
                        <ListItem dense>
                          <ListItemText
                            primary="Heure coût budget :"
                            secondary={parseFloat(String(reforecaste?.heure_cout_budget))?.toFixed(2)}
                          />
                        </ListItem>
                      </>
                    )}

                    {reforecaste?.dmt && (
                      <>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: " #dfdfdf" }}
                        />
                        <ListItem dense>
                          <ListItemText
                            primary="DMT :"
                            secondary={
                              <Box display="flex" alignItems="center" gap={0.5} sx={{ color: 'text.secondary', mt: 0.5 }}>
                                <AccessTimeIcon sx={{ fontSize: '1rem' }} />
                                <span>{reforecaste?.dmt}</span>
                              </Box>
                            }
                          />
                        </ListItem>
                      </>
                    )}

                    {reforecaste?.taux_occupation !== null && reforecaste?.taux_occupation !== undefined && (
                      <>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: " #dfdfdf" }}
                        />
                        <ListItem dense>
                          <ListItemText
                            primary="Taux occupation :"
                            secondary={`${reforecaste?.taux_occupation} %`}
                          />
                        </ListItem>
                      </>
                    )}

                    {reforecaste?.taux_conges !== null && reforecaste?.taux_conges !== undefined && (
                      <>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: " #dfdfdf" }}
                        />
                        <ListItem dense>
                          <ListItemText
                            primary="Taux congés :"
                            secondary={`${reforecaste?.taux_conges} %`}
                          />
                        </ListItem>
                      </>
                    )}

                    {reforecaste?.taux_absenteisme !== null && reforecaste?.taux_absenteisme !== undefined && (
                      <>
                        <Divider
                          orientation="horizontal"
                          sx={{ bgcolor: " #dfdfdf" }}
                        />
                        <ListItem dense>
                          <ListItemText
                            primary="Taux absentéisme :"
                            secondary={`${reforecaste?.taux_absenteisme} %`}
                          />
                        </ListItem>
                      </>
                    )}
                  </List>
                </CardContent>
              </Card>
            </Stack>
          </AccordionDetails>
        </Accordion>
      )}

      <Dialog
        open={openModalDelete}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDeleteModal}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {deleteMessageConfirmation}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={() => handleDelete()}
            startIcon={<DeleteIcon />}
            loading={deleteLoading}
            loadingPosition="end"
            sx={btnStyle({
              bgColor: "#FF0000",
              hoverColor: "#FE3737",
            })}
            variant="contained"
          >
            Oui
          </LoadingButton>
          <LoadingButton
            onClick={() => handleCloseDeleteModal()}
            startIcon={<ExitToAppIcon />}
            sx={{ textTransform: "none" }}
            loadingPosition="end"
            variant="contained"
            color="inherit"
          >
            Non
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <OptionalWidthModal
        title="Modification Reforecaste"
        onClose={handleClose}
        open={openModal}
        breackPoint="md"
      >
        <UpdateReforecastForm
          budget={reforecaste}
          http={http}
          profil={user?.profils?.libelle}
          onClose={handleClose}
          setOpenSnack={setOpenSnack}
          setAlerteMessage={setAlerteMessage}
          setAlertType={setAlertType}
          reloadList={reloadList}
        />
      </OptionalWidthModal>

      <OptionalWidthModal
        title="Dupliquer un reforcaste"
        onClose={handleCloseDuplicateModal}
        open={openDuplicateModal}
        breackPoint="md"
      >
        <DuplicateReforecastForm
          budget={reforecaste}
          http={http}
          profil={user?.profils?.libelle}
          onClose={handleCloseDuplicateModal}
          setOpenSnack={setOpenSnack}
          setAlerteMessage={setAlerteMessage}
          setAlertType={setAlertType}
          reloadList={reloadList}
        />
      </OptionalWidthModal>
    </>
  );
};

export default ReforecastRow;